import { useSelector } from 'react-redux';
import { userUUIDSelector } from '../redux/selectors/userUUIDSelector';

const useUserUUID = () => useSelector(userUUIDSelector);

export default useUserUUID;
